import { Component, ChangeDetectionStrategy, ElementRef, Renderer2, Input, NgModule } from '@angular/core';
import { __extends } from 'tslib';
import { FieldType } from '@ngx-formly/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PasswordVisibleInputComponent = /** @class */ (function () {
    function PasswordVisibleInputComponent(elem, renderer) {
        this.elem = elem;
        this.renderer = renderer;
        this.color = '';
        this.raised = false;
        this.mode = 'mousedown';
        this.isShowing = false;
    }
    /**
     * @return {?}
     */
    PasswordVisibleInputComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.input = this.elem.nativeElement.querySelector('input');
        if (!this.input) {
            throw new Error("No input element found.");
        }
        this.renderer.setStyle(this.input, 'flex', '1');
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    PasswordVisibleInputComponent.prototype.toggleShowing = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        if (this.mode === 'toggle') {
            this.isShowing = !this.isShowing;
            this.updateInputType();
        }
    };
    /**
     * @private
     * @return {?}
     */
    PasswordVisibleInputComponent.prototype.updateInputType = /**
     * @private
     * @return {?}
     */
    function () {
        this.renderer.setAttribute(this.input, 'type', this.isShowing ? 'text' : 'password');
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    PasswordVisibleInputComponent.prototype.mousedown = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        if (this.mode === 'mousedown') {
            this.isShowing = true;
            this.updateInputType();
        }
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    PasswordVisibleInputComponent.prototype.mouseup = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        if (this.mode === 'mousedown') {
            this.isShowing = false;
            this.updateInputType();
        }
    };
    PasswordVisibleInputComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ngx-password-visible-input',
                    template: "<ng-content></ng-content>\n<button mat-button [color]=\"color\" [ngClass]=\"(raised ? 'mat-raised-button' : '' )\" type=\"button\" \n  (click)=\"toggleShowing($event)\" (mousedown)=\"mousedown($event)\" (mouseup)=\"mouseup($event)\">\n  <mat-icon>{{isShowing ? 'visibility' : 'visibility_off'}}</mat-icon>\n</button>",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [":host{position:relative;display:flex;flex-wrap:wrap;align-items:stretch;width:100%;flex-direction:row}"]
                }] }
    ];
    /** @nocollapse */
    PasswordVisibleInputComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 }
    ]; };
    PasswordVisibleInputComponent.propDecorators = {
        color: [{ type: Input }],
        raised: [{ type: Input }],
        placeholder: [{ type: Input }],
        formControlName: [{ type: Input }],
        mode: [{ type: Input }]
    };
    return PasswordVisibleInputComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FormlyFieldPasswordVisibleInputComponent = /** @class */ (function (_super) {
    __extends(FormlyFieldPasswordVisibleInputComponent, _super);
    function FormlyFieldPasswordVisibleInputComponent() {
        return _super.call(this) || this;
    }
    Object.defineProperty(FormlyFieldPasswordVisibleInputComponent.prototype, "type", {
        get: /**
         * @return {?}
         */
        function () {
            return this.to.type || 'text';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormlyFieldPasswordVisibleInputComponent.prototype, "name", {
        get: /**
         * @return {?}
         */
        function () {
            return this.model[this.key] ? this.model[this.key].name : '';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} event
     * @return {?}
     */
    FormlyFieldPasswordVisibleInputComponent.prototype.onChanged = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        // tslint:disable-next-line: no-non-null-assertion
        (/** @type {?} */ (this.field.formControl)).setValue(event.target.value);
    };
    FormlyFieldPasswordVisibleInputComponent.decorators = [
        { type: Component, args: [{
                    template: "<ngx-password-visible-input>\n    <input type=\"password\" matInput [placeholder]=\"placeholder\" (change)=\"onChanged($event)\">\n</ngx-password-visible-input>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    FormlyFieldPasswordVisibleInputComponent.ctorParameters = function () { return []; };
    FormlyFieldPasswordVisibleInputComponent.propDecorators = {
        placeholder: [{ type: Input }]
    };
    return FormlyFieldPasswordVisibleInputComponent;
}(FieldType));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NgxPasswordVisibleInputLibModule = /** @class */ (function () {
    function NgxPasswordVisibleInputLibModule() {
    }
    NgxPasswordVisibleInputLibModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        PasswordVisibleInputComponent,
                        FormlyFieldPasswordVisibleInputComponent
                    ],
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        MatIconModule,
                        MatInputModule,
                        MatButtonModule,
                    ],
                    exports: [
                        PasswordVisibleInputComponent,
                        FormlyFieldPasswordVisibleInputComponent
                    ]
                },] }
    ];
    return NgxPasswordVisibleInputLibModule;
}());

export { FormlyFieldPasswordVisibleInputComponent, NgxPasswordVisibleInputLibModule, PasswordVisibleInputComponent };
//# sourceMappingURL=ngx-password-visible-input.js.map
